<template>
  <div style="background: url(static/images/hello-i-m-nik-zYdYz7JlevE-unsplash.jpg) no-repeat center / cover; width: 100%; height: 100%;">
    <div class="row-bg">
      <img class="img-fluid" src="static/images/logo.svg" alt="" style="width: 80px;"/>
      <h2 style="padding-bottom: 25px;">登录 SUMIUX 体验管理平台</h2>
      <div class="login-form">
        <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="100px" @submit.native.prevent="handleEnterKey">
          <el-form-item class="form-item" label="用户名" prop="username">
            <el-input v-model="loginForm.username" @keyup.enter.native="handleEnterKey"></el-input>
          </el-form-item>
          <el-form-item class="form-item" label="密码" prop="password">
            <el-input v-model="loginForm.password" type="password" @keyup.enter.native="handleEnterKey"></el-input>
          </el-form-item>
          <el-form-item class="form-item" label="验证码" prop="code">
            <el-input v-model="loginForm.code"  style="width: 150px; float: left" maxlength="5" @keyup.enter.native="handleEnterKey"></el-input>
            <el-image :src="captchaImg" class="captchaImg" @click="getCaptcha"></el-image>
          </el-form-item>

          <el-form-item class="form-item">
            <el-button style="width: 100%;" type="primary" :disabled="submitting" @click="submitForm('loginForm')">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

	import qs from 'qs'

	export default {
		name: "Login",
      data() {
        return {
          loginForm: {
            username: '',
            password: '',
            code: '',
            token: ''
          },
          submitting: false,
          rules: {
            username: [
              { required: true, message: '请输入用户名', trigger: 'blur' }
            ],
            password: [
						{ required: true, message: '请输入密码', trigger: 'blur' }
					],
					code: [
						{ required: true, message: '请输入验证码', trigger: 'blur' },
						{ min: 5, max: 5, message: '长度为 5 个字符', trigger: 'blur' }
					],
				},
				captchaImg: null
			};
		},
      methods: {
        handleEnterKey(event) {
          // 阻止默认行为，防止表单提交
          if (event) {
            event.preventDefault()
            event.stopPropagation()
          }
          // 调用登录方法
          this.submitForm('loginForm')
        },
        submitForm(formName) {
        if (this.submitting) return;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitting = true
            this.$axios.post('/login?'+ qs.stringify(this.loginForm)).then(res => {
              const jwt = res.headers['Authorization'] || res.headers['authorization']
              this.$store.commit('SET_TOKEN', jwt)
              // 使用 nextTick 确保 token 已保存后再跳转
              this.$nextTick(() => {
                // 使用 replace 而不是 push，避免导航冲突
                this.$router.replace("/index").catch(err => {
                  // 忽略导航相关的错误（重复导航、取消导航等）
                  if (err && (
                    (err.name && err.name === 'NavigationDuplicated') || 
                    (err.message && err.message.includes('Navigation cancelled'))
                  )) {
                    // 导航被取消或重复，忽略错误
                    return
                  }
                  console.error('路由跳转失败:', err)
                })
              })
              this.submitting = false
            }).catch(() => {
              this.submitting = false
            })
          } else {
            return false;
          }
        });
        },
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			getCaptcha() {
				this.$axios.get('/captcha').then(res => {

					console.log("/captcha success")
					console.log(res)

					// 正确的数据访问路径：从res.data.data获取数据
					this.loginForm.token = res.data.data.token
					this.captchaImg = res.data.data.captchaImg
					this.loginForm.code = ''
				}).catch(error => {
					console.error("/captcha error:", error)
					this.$message.error('验证码加载失败: ' + (error.message || '未知错误'))
				})
			}
		},
		created() {
			this.getCaptcha()
		}
	}
</script>

<style scoped>

	.row-bg {
    text-align: center;
    padding-top: 150px;
   }

	.captchaImg {
		float: left;
		margin-left: 8px;
		border-radius: 4px;
	}

  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 480px;
  }

  .form-item {
    width: 380px;
    font-weight: bold;
  }

</style>
